import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import ServiceCard from '../ServiceCard/ServiceCard';
const Seat = props => {
    const { t } = useTranslation('Checkout');
    const theme = useTheme('RefundSummary').CommonContent;
    const getServiceName = (service, productId, passengerId) => {
        var _a, _b;
        const traveller = props.passengers.find(passenger => passenger.id === passengerId);
        const seat = (_b = (_a = traveller.services) === null || _a === void 0 ? void 0 : _a.seats) === null || _b === void 0 ? void 0 : _b.find(seat => {
            return seat.product.id === productId;
        });
        let segment;
        if (Array.isArray(props.flight)) {
            segment = props.flight.find(segment => segment.id === seat.segment.id);
        }
        else {
            segment = props.flight.segments.find(segment => segment.segment.id === seat.segment.id).segment;
        }
        return (React.createElement(React.Fragment, null,
            segment.departure.airport.iata,
            " - ",
            segment.arrival.airport.iata,
            ", ",
            seat.seat.number));
    };
    return (React.createElement(ServiceCard, Object.assign({ type: "seats", className: theme.serviceCard_seats, title: t('Seats'), description: "", getServiceName: getServiceName }, props)));
};
export default Seat;
